import Constants from 'expo-constants';

/**
 * Public URL of your lesson generator (e.g. https://your-app.vercel.app).
 * Set in app.json → expo.extra.LESSON_GENERATOR_URL
 * Leave empty to keep the static login image instead.
 */
export function getLessonGeneratorUrl(): string {
  const fromExtra = Constants.expoConfig?.extra?.LESSON_GENERATOR_URL;
  if (typeof fromExtra === 'string' && fromExtra.trim().length > 0) {
    return fromExtra.trim();
  }
  return '';
}
